import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import ActionBar from './ActionBar'
import {connect} from 'react-redux'
import StaffDetail from './StaffDetail'
import StaffList from './StaffList'
import {
  onChangeKeyword,
  onClickInviteStaff,
  onClickExport,
  pageRequest,
  onClickRow,
  onClickAssignOutlet,
  onConfirmAssignOutlet,
  onCancelAssignOutlet,
  onSubmitForm,
  onCancelDeleteEmployee,
  onConfirmDeleteEmployee,
  onClickDeleteEmployee,
  onClickResendInvitation,
  onClickResendWithValidCaptcha,
  onCancelResend,
  hidePinRequiredModal
} from 'actions/employees/staff'
import EmptyState from './EmptyState'
import {formValueSelector, isDirty} from 'redux-form'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import ConfirmActionModal from 'components/ConfirmActionModal'
import ResendCaptchaModal from './StaffList/ResendCaptchaModal'
import PinRequiredModal from './PinRequiredModal'

class Staff extends React.Component {
  componentDidMount () {
    const {user, dispatch, expired} = this.props
    if (expired) {
      browserHistory.push('/settings/billing')
    } else {
      dispatch(pageRequest({user}))
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtyStaff && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    }
  }

  render () {
    const {openRightColumn, employees, submitting, employeeDetail, outlets, roles, user, pinRequiredModal} = this.props
    const hasStaff = (employees.length > 0)
    const hasRole = (roles.length > 0)
    const showLoadingSpinner = submitting !== null
    return (<PageWrapper>
      <ActionBar
        onChangeSearch={this._onChangeSearch}
        onClickExport={this._onClickExport}
        onClickInviteStaff={this._onClickInviteStaff}
        enableInviteStaff
        enableExportStaff={hasRole}
      />
      <ContentWrapper>
        <LeftColumnWrapper openRightColumn={openRightColumn}>
          {!(hasRole && hasStaff) && <EmptyState
            hasRole={hasRole}
            hasStaff={hasStaff}
            canAccessRole={user.is_owner}
            showLoadingSpinner={showLoadingSpinner}
          />}
          {(hasRole && hasStaff && outlets.length > 0) && <StaffList
            employees={this.props.employees}
            onClickRow={this._onClickRow}
            employeeDetail={employeeDetail}
            outlets={outlets}
            onClickResendInvitation={this._onClickResendInvitation}
          />}
        </LeftColumnWrapper>
        <RightColumnWrapper openRightColumn={openRightColumn}>
          {outlets.length > 0 && openRightColumn && <StaffDetail
            outlets={outlets}
            roles={roles}
            onSubmit={this._onSubmit}
            onClickCancelAssignOutletModal={this._onClickCancelAssignOutletModal}
            onClickConfirmAssignOutletModal={this._onClickConfirmAssignOutletModal}
            onCancelDeleteEmployee={this._onCancelDeleteEmployee}
            onConfirmDeleteEmployee={this._onConfirmDeleteEmployee}
            onClickDeleteEmployee={this._onClickDeleteEmployee}
            onClickFormAssignOutlet={this._onClickFormAssignOutlet}
            showAssignOutletModal={this.props.showAssignOutletModal}
            showEmployeeDeleteModal={this.props.showEmployeeDeleteModal}
            employeeDetail={employeeDetail}
            formValues={this.props.formValues}
            selfView={employeeDetail && this.props.user.id === employeeDetail.id}
            submitting={this.props.submitting}
          />}
        </RightColumnWrapper>
      </ContentWrapper>
      <ConfirmActionModal />
      <ResendCaptchaModal show={this.props.showResendCaptchaModal}
        onClickWithValidCaptcha={this._onClickResendWithValidCaptcha}
        onCancel={this._onCancelResend}
      />
      <PinRequiredModal
        show={this.props.showPinRequiredModal}
        mode={this.props.employeeDetail ? 'edit' : 'create'}
        onConfirm={this._onConfirmPinRequiredModal}
        message={pinRequiredModal.message}
      />
    </PageWrapper>)
  }

  _onSubmit = ({values}) => {
    const {dispatch, employees, outlets, roles, user} = this.props
    // get related role for mixpanel (and maybe other stuff)
    let role = {}
    // if the user edit his/her data
    // the role_id dropdown cannot be edited and the 'roles' value will not contain data related to his/her role
    // because administrator cannot see 'administator role' in endpoint /roles
    // so the role object will be get from 'employees' not the 'roles'
    if (user.id !== values.id) {
      roles.forEach((r) => {
        if (`${r.id}` === `${values.role_id}`) {
          role = r
        }
      })
    } else {
      employees.forEach((e) => {
        if (e.id === values.id) {
          role = {...e.role}
        }
      })
    }
    dispatch(onSubmitForm({values: {...values, email: values.email.toLowerCase()}, previousEmployees: employees, outlets, role}))
  }

  _onChangeSearch = ({trigger, keyword}) => {
    const {dispatch, user} = this.props
    if (trigger === 'keyword') {
      dispatch(onChangeKeyword({keyword, user}))
    }
  }

  _onClickInviteStaff = () => {
    const {dispatch, isDirtyStaff} = this.props
    if (isDirtyStaff) {
      dispatch(askConfirmAction(onClickInviteStaff()))
    } else {
      dispatch(onClickInviteStaff())
    }
  }

  _onClickResendInvitation = ({email}) => {
    const {dispatch} = this.props
    dispatch(onClickResendInvitation({email}))
  }

  _onClickExport = () => {
    const {dispatch, employees, user} = this.props
    dispatch(onClickExport({employees, user}))
  }

  _onClickRow = ({employee}) => {
    const {dispatch, isDirtyStaff} = this.props
    if (isDirtyStaff) {
      dispatch(askConfirmAction(onClickRow({employee})))
    } else {
      dispatch(onClickRow({employee}))
    }
  }

  _onClickCancelAssignOutletModal = () => {
    this.props.dispatch(onCancelAssignOutlet())
  }

  _onClickConfirmAssignOutletModal = ({assignedOutletIds}) => {
    this.props.dispatch(onConfirmAssignOutlet({assignedOutletIds}))
  }

  _onClickFormAssignOutlet = () => {
    this.props.dispatch(onClickAssignOutlet())
  }

  _onCancelDeleteEmployee = () => {
    this.props.dispatch(onCancelDeleteEmployee())
  }

  _onConfirmDeleteEmployee = () => {
    const {employeeDetail, dispatch, employees} = this.props
    dispatch(onConfirmDeleteEmployee({employee: employeeDetail, previousEmployees: employees}))
  }

  _onClickDeleteEmployee = () => {
    this.props.dispatch(onClickDeleteEmployee())
  }

  _onCancelResend = () => {
    const {dispatch} = this.props
    dispatch(onCancelResend())
  }

  _onClickResendWithValidCaptcha = () => {
    const {resendCaptchaEmail, dispatch} = this.props
    dispatch(onClickResendWithValidCaptcha({email: resendCaptchaEmail}))
  }

  _onConfirmPinRequiredModal = () => {
    const {dispatch} = this.props
    dispatch(hidePinRequiredModal())
  }
}

const selector = formValueSelector('staff')

function mapStateToProps (state) {
  const {
    openRightColumn,
    employees,
    submitting,
    employeeDetail,
    outlets,
    showAssignOutletModal,
    roles,
    showEmployeeDeleteModal,
    showResendCaptchaModal,
    resendCaptchaEmail,
    canAccessRole,
    showPinRequiredModal,
    pinRequiredModal
  } = state.employee.staff
  const {user} = state.moka
  const {expired} = state.subscriptionExpired
  return {
    openRightColumn,
    employees,
    submitting,
    employeeDetail,
    user: {
      id: user.id,
      is_owner: user.is_owner,
      is_manager: user.is_manager,
      business: {
        name: user.business.name
      }
    },
    outlets,
    showAssignOutletModal,
    showEmployeeDeleteModal,
    showResendCaptchaModal,
    resendCaptchaEmail,
    roles,
    formValues: {
      id: selector(state, 'id'),
      email: selector(state, 'email'),
      outlets: selector(state, 'outlets'),
      assign_pin: selector(state, 'assign_pin'),
      pin: selector(state, 'pin')
    },
    isDirtyStaff: isDirty('staff')(state),
    expired,
    nextAction: state.confirmAction.nextAction,
    canAccessRole,
    showPinRequiredModal,
    pinRequiredModal: {
      message: pinRequiredModal.message
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Staff)



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/Staff.js